export default function Main() {
  return (
    <>
      <div id="main">
          <img className="mainimg" src="/assets/images/vliegen.png" alt="Vliegen die chocolade eten schijten bruine stippen" />
      </div>
    </>
  )
}